import { createRoot } from "react-dom/client";
import { App } from "./core/App";
import "./styles/app.css";
// PEAU 09/2026 : jetons + classes ajoutés (spec 2026-09-08). Chargé juste
// après app.css — voir l'en-tête de peau.css : il n'AJOUTE que, il ne
// redéfinit jamais un sélecteur de base d'app.css.
import "./styles/peau.css";
// Surcharges du cadre externe. Elles l'emportent par SPÉCIFICITÉ
// (`.embed.plein` = 2 classes contre 1), pas par ordre d'import — l'ordre
// n'est donc pas porteur ici. On le garde après app.css par convention, et
// pour qu'une future règle de spécificité égale se comporte comme attendu.
import "./styles/cadre-plein.css";
import "./styles/nav-mobile.css";
// Les jetons shadcn traduisent la palette du CRM en HSL ; ils doivent être
// posés AVANT les utilitaires qui s'y réfèrent.
import "./styles/shadcn-tokens.css";
// Tailwind en DERNIER : à spécificité égale, une classe utilitaire l'emporte
// sur le CSS historique. Les seize écrans existants n'en utilisent aucune, donc
// rien ne bouge pour eux — c'est ce que vérifie `tailwind-cohabitation.test.ts`.
import "./styles/tailwind.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Élément #root introuvable");
createRoot(rootEl).render(<App />);
